import { render } from "./bookCard.vue?vue&type=template&id=4ca51f3a&scoped=true"
import script from "./bookCard.vue?vue&type=script&lang=js"
export * from "./bookCard.vue?vue&type=script&lang=js"

import "./bookCard.vue?vue&type=style&index=0&id=4ca51f3a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca51f3a"]])

export default __exports__